/*
  Collection vehicle pop-up.

  Deliberately thin: the Year/Make/Model form inside the modal is the YMM app's own widget
  (cloned into `.easysearch-embed-widget-main` at boot), so the cascade, the saved vehicle and
  the search URL are all still the app's job. This file only decides when the modal is on screen
  and fills in the two things Liquid cannot know — the vehicle's name and its results URL, both
  of which live in localStorage.

  Whether a vehicle is selected is already on <html> as .ymm-has-vehicle / .ymm-no-vehicle
  (snippets/ymm-popup-state.liquid, runs in <head>), which is what keeps the page from flashing.
*/
(function () {
  'use strict';

  var UNIVERSAL_TAG = 'nm-es-universal';
  var body = document.body;
  var modal = document.querySelector('[data-ymm-modal]');
  var lastFocused = null;

  function vehicle() {
    return window.ymmVehicle || { name: null, tag: null };
  }

  function hasVehicle() {
    return !!vehicle().name;
  }

  /* ------------------------------------------------------------------ copy */

  function applyCopy() {
    var name = vehicle().name;

    if (modal) {
      ['[data-ymm-heading]', '[data-ymm-body]'].forEach(function (selector) {
        var el = modal.querySelector(selector);
        if (!el) return;
        var text = name ? el.dataset.change : el.dataset.default;
        if (!text) return;
        el.textContent = name ? text.replace('[vehicle]', name) : text;
      });
    }

    // "We couldn't find any Mud Flaps for your 2025 Acura TLX."
    document.querySelectorAll('[data-ymm-empty-body]').forEach(function (el) {
      var template = el.dataset.template;
      if (!template) return;
      el.textContent = template.replace('[vehicle]', name || 'your vehicle');
    });
  }

  /* ------------------------------------------------------- view all products */

  // The vehicle's own results page: every product tagged for this vehicle plus the universal
  // ones, across the whole catalogue rather than the collection being viewed.
  function viewAllUrl() {
    var tag = vehicle().tag;
    if (!tag) return null;

    var tags = tag.split('+').filter(Boolean);
    if (!tags.length) return null;
    if (tags.indexOf(UNIVERSAL_TAG) === -1) tags.push(UNIVERSAL_TAG);

    return (
      '/collections/all?' +
      tags
        .map(function (value) {
          return 'filter.p.tag=' + encodeURIComponent(value);
        })
        .join('&')
    );
  }

  function applyViewAllLinks() {
    var url = viewAllUrl();
    if (!url) return;
    document.querySelectorAll('[data-ymm-view-all]').forEach(function (link) {
      link.setAttribute('href', url);
    });
  }

  /* ----------------------------------------------------------- open / close */

  function focusables() {
    return Array.prototype.filter.call(
      modal.querySelectorAll('button, a[href], select, input, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        return el.offsetParent !== null;
      }
    );
  }

  function open() {
    if (!modal || !modal.hasAttribute('hidden')) return;
    lastFocused = document.activeElement;
    applyCopy();
    modal.removeAttribute('hidden');
    body.classList.add('ymm-popup-open');

    // The card, not the first control: focusing the ✕ draws the theme's focus ring around it.
    var dialog = modal.querySelector('.ymm-popup-dialog');
    if (dialog) dialog.focus({ preventScroll: true });
  }

  function close() {
    if (!modal || modal.hasAttribute('hidden')) return;
    modal.setAttribute('hidden', '');
    body.classList.remove('ymm-popup-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
    }
  }

  function onKeydown(event) {
    if (!modal || modal.hasAttribute('hidden')) return;

    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    var items = focusables();
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---------------------------------------------------------------- auto open */

  // The modal is only worth showing once the app has cloned its widget into it — an empty card
  // would be worse than no card. Give it a couple of seconds, then give up quietly.
  function openWhenWidgetReady() {
    if (!modal || modal.dataset.ymmAuto !== 'true' || hasVehicle()) return;

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (modal.querySelector('.easysearch-widget')) {
        clearInterval(timer);
        open();
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 100);
  }

  /* -------------------------------------------------------------------- init */

  // The empty state carries its own pair of buttons, so the pair under the collection title
  // would be a second copy of the same two actions on the same screen. The title row stands
  // down while the empty state is up (it lives in another section, hence the body class).
  function syncEmptyState() {
    body.classList.toggle('ymm-has-empty', !!document.querySelector('[data-ymm-empty]'));
  }

  function init() {
    applyCopy();
    applyViewAllLinks();
    syncEmptyState();

    // Delegated: the empty state lives inside the product grid, which the facet form re-renders.
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-ymm-open]')) {
        event.preventDefault();
        open();
        return;
      }
      if (modal && !modal.hasAttribute('hidden') && event.target.closest('[data-ymm-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', onKeydown);

    // Filtering swaps the grid — the empty state comes back as fresh markup that still needs the
    // vehicle name and the results URL.
    document.addEventListener('collection:product-filters', function () {
      applyCopy();
      applyViewAllLinks();
      syncEmptyState();
    });

    openWhenWidgetReady();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
